import React, { useEffect, useState, useMemo } from 'react';
import { Button, Col, Container, Form, Pagination, Row, Spinner, Table } from 'react-bootstrap';

import { useLocation, Link } from 'react-router-dom'

import api from '../../api/api';
import SchemeSidebarFilter from './SchemeSidebarFilter';

import SchemeDetails from './SchemeDetails'; // New Details component

import 'bootstrap/dist/css/bootstrap.min.css'; // Make sure Bootstrap CSS is imported
import '../custom_styles.css';

import SchemeTable from './scheme_table.js';
import WatchListModal from '../../components/WatchListModal';

export default function SchemeCompareList({
  filters = null,
}) {
  const NO_USER_MANAGED_SORT=true;

  const [schemes, setSchemes] = useState([]);
  const location = useLocation();

  const {baseScheme, categoryName, typeName, routerURL, urlParams, isAddToWatchlistApplicableState, originatorInfo } = location.state;
  const [loading, setLoading] = useState(true);
//  const schemeCode = new URLSearchParams(window.location.search).get('schemeCode');
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [navigationURL, setNavigationURL] = useState('/update-my-watchlist');

  // For Details
  const [selectedSchemeCode, setSelectedSchemeCode] = useState(null);
  const [selectedScheme, setSelectedScheme] = useState(null);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [addToWatchListMessage, setAddToWatchListMessage] = useState("");
  const [selectedIds, setSelectedIds] = useState([]);
  const [multiSelect, setMultiSelect] = useState(false);
  // 
  useEffect(() => {
      setLoading(true);
      api.get('/user-scheme-similar', { params: {'SchemeCode': baseScheme.scheme_code } })
        .then(res => { /** console.log(res.data); **/ setSchemes(res.data)})
        .catch(err => setError('Failed to load schemes.'))
        .finally(() => setLoading(false));
  }, [baseScheme]);

  // Click handler for details
  const handleCellClick= (scheme, columnName) => {
    if (scheme.scheme_code === baseScheme.scheme_code) {
      return;
    }
    if (selectedSchemeCode && (selectedSchemeCode === scheme.scheme_code)) {
       setSelectedScheme(null);
       setSelectedSchemeCode(null);
       return;
    }; // Already selected
    setSelectedSchemeCode(scheme.scheme_code);
    setSelectedScheme(scheme);
  };

  const handleCloseSidebar = () => {
    setSelectedScheme(null);
    // setShowSidebar(false);
  };

  // Sorting
  const [sortField, setSortField] = useState('');
  const [sortDir, setSortDir] = useState('desc');  // 'asc';

  // Pagination
  const [pageSize, setPageSize] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);

  // Filter + sort + topX
  const filtered = useMemo(() => {
    let data = [...schemes];

    if (filters && filters.fundHouses && (filters.fundHouses.length > 0)) {
      data = data.filter((s) => {
        // console.log("*** filtered, fundId ", s.fundId);
        return filters.fundHouses.some(fundHouse => s.fundId === Number(fundHouse));
      });
    }
    //   if (typeof vA === 'string') vA = vA.toLowerCase();
    //   if (typeof vB === 'string') vB = vB.toLowerCase();
    if (NO_USER_MANAGED_SORT) {
      return data;
    }
    data.sort((a, b) => {
      if (sortField.length == 0) return 0; 
      let vA = a[sortField], vB = b[sortField];
      if (vA < vB) return sortDir === 'asc' ? -1 : 1;
      if (vA > vB) return sortDir === 'asc' ? 1 : -1;
      return 0;
    });

    return data;
  }, [schemes, filters, sortField, sortDir, NO_USER_MANAGED_SORT]);

  // Pagination logic
  const totalPages = Math.ceil(filtered.length / pageSize);
  const pageData = filtered.slice((currentPage - 1) * pageSize, currentPage * pageSize);
  const goToPage = (num) => setCurrentPage(num);

  // Sorting handler
  const handleSort = (field) => {
    if (NO_USER_MANAGED_SORT) {
      return;
    }
    if (sortField && (sortField === field)) setSortDir(sortDir === 'asc' ? 'desc' : 'asc');
    else { setSortField(field); setSortDir('asc'); }
  };

  const renderSimpleSort = (field) => {
    if (NO_USER_MANAGED_SORT) {
      return  "";
    } else {
      return (sortField === field ? (sortDir === 'asc' ? '▲' : '▼') : '⇅');
    };
  };

  const processAddToWatchList = async (watchListName, addNewWatchlist) => {
    const payload = {
      watchlistName: watchListName,
      addNewWatchList: addNewWatchlist,
      selectedSchemes: [selectedScheme.id]
    };

    setAddToWatchListMessage("");
    try {
      const res = await api.post('/update-my-watchlist', payload); // JSON.stringify([selectedScheme.id]));
      if (res.status === 200) {
        setAddToWatchListMessage(res.data.message || 'Successfully Added Scheme to WatchList');
      } else if (res.status >= 400) {
        setAddToWatchListMessage(res.data.error || 'Could not add Scheme to WatchList');
      }
      return res.data
    } catch (err) {
      // setShow(true);
      setAddToWatchListMessage(err.response?.data?.message || err.response?.data?.error || 'Could not add Scheme to WatchList');
    }
  }

  const handleWatchListSubmit = async (data) => {
    setShowModal(false);
    processAddToWatchList(data.watchlistName, data.addNewWatchlist);
  }

  const handleAddSchemeSubstitute = async () => {
    const payload = {
      watchlistName: originatorInfo?.watchlistName,
      watchlistScheme_id: baseScheme.id,
      substituteScheme_ids: [selectedScheme.id]
    };
    setAddToWatchListMessage("");
    try {
      const res = await api.post('/add-watchlist-scheme-substitute', payload); // JSON.stringify([selectedScheme.id]));
      if (res.status === 200) {
        setAddToWatchListMessage(res.data.message || "Successfully Added Scheme to WatchList Schemes' Substitute list");
      } else if (res.status >= 400) {
        setAddToWatchListMessage(res.data.error || "Could not add Scheme to WatchList Schemes' Substitute list");
      }
      return res.data
    } catch (err) {
      // setShow(true);
      setAddToWatchListMessage(err.response?.data?.message || err.response?.data?.error || 'Could not add Scheme to WatchList');
    }
  }
  
  return (
    <>
      <div className="container-fluid" fluid="sm">
        <Row>
            <Col xl={selectedScheme ? 8 : 12} style={{fontSize:'0.90rem'}}>
              {/* Table + Filters */}
              {loading ? (
                <Spinner animation="border" />
              ) : (
                <>
                  <h5>Schemes with similar investment pattern as <b>"{baseScheme.name}"</b><span responsive style={{'fontSize':'0.90rem'}}>(known launch date : {baseScheme.launchDate})</span></h5>
                  <h6 className="ms-4 me-2 mt-2 mb-3" ><span responsive style={{'fontSize':'0.90rem'}}>
                    The scheme has <b>'Predicted Volatility'</b>: {baseScheme.predVolatility}, <b>'Prediction Analysis'</b>: {baseScheme.predAnalysis}  and <b>'pNAV Max - Returns Trend'</b>: {baseScheme.maxProbableReturns}..
                    <br/>
                    Historical Performance indicate <b>'CAGR Percentage': {baseScheme.cagr_percentage_as_of_last_actual}</b>, 'Annualized 1yr, 3yr & 5yr Returns (resp.ly)': {baseScheme.annualizedReturns1}, {baseScheme.annualizedReturns3}, {baseScheme.annualizedReturns5}.
                    </span>
                </h6>
                  <Form className="mb-1 mt-1">
                    <Row>
                      <Col xs={2}>
                        <Form.Select value={pageSize} onChange={e => {setPageSize(Number(e.target.value)); setCurrentPage(1);}}>
                          {[20, 35, 50].map(sz => (<option key={sz} value={sz}>Show {sz} per page</option>))}
                        </Form.Select>
                      </Col>
                      <Col xs={3}>
                        <Button as={Link} to={routerURL? routerURL : "/dashboard"} 
                                state={(location.state?.urlParams) ? urlParams : {'no_Watchlist_Param':''}}
                                className="ms-2 btn-alternate-path">
                                Back to SchemeList
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                  <SchemeTable pageData={pageData} baseScheme={baseScheme}
                              handleCellClick={handleCellClick}
                              handleSort={handleSort}
                              renderSimpleSort={renderSimpleSort}
                              selectedScheme={selectedScheme}
                              sortField={sortField}
                              sortDir={sortDir} 
                              isAddToWatchlistApplicable={isAddToWatchlistApplicableState}

                    />
                  <Pagination className="my-3 justify-content-center">
                    {[...Array(totalPages)].map((_, i) => (
                      <Pagination.Item key={i+1} active={currentPage === i+1} onClick={() => goToPage(i+1)}>
                        {i+1}
                      </Pagination.Item>
                    ))}
                  </Pagination>
                </>
              )}
            </Col>
            {selectedScheme &&
              <Col xl={4} className="border-start">
                  <Row>
                      <Button variant="outline-secondary" onClick={handleCloseSidebar} className="mt-1">
                        Close
                      </Button>

                  </Row>
                  <Row>
                    {detailsLoading
                      ? <Spinner animation="border" /> 
                      : <SchemeDetails scheme={selectedScheme} categoryName={categoryName}
                                    typeName={typeName}/>
                    } 
        
                  </Row>
                  {isAddToWatchlistApplicableState ?
                    (<Row>
                          <Col xs={6} className="text-start">
                              <Button variant="outline-secondary" 
                                      onClick={() =>  {setNavigationURL('/update-my-watchlist'); setShowModal(true)}} className="mt-2">
                                  <b>Add this Scheme {selectedScheme.name} to my WatchList</b>
                              </Button>
                          </Col>
                          <Col xs={6} className="text-end">
                              <span style={{fontSize:'0.90rem'}}>{addToWatchListMessage}</span>
                          </Col>
                        </Row>
                    ) : (<></>)
                  }
                  {originatorInfo?.isAncestorWatchlist ?
                    ( <Row>
                          <Col xs={6} className="text-start">
                              <Button variant="outline-secondary" onClick={() => {setNavigationURL('/add-watchlist-scheme-substitute'); handleAddSchemeSubstitute()}} className="mt-2">
                                  <b>Add this Scheme ({selectedScheme.name}) to parent Watchlist Scheme's ({baseScheme.name}) list of possible substitutes</b>
                              </Button>
                          </Col>
                          <Col xs={6} className="text-end">
                              <span style={{fontSize:'0.90rem'}}>{addToWatchListMessage}</span>
                          </Col>
                      </Row>
                    ) : (<></>)
                  }
              </Col>
            }
        </Row>
      </div>
      {isAddToWatchlistApplicableState ?
        (<WatchListModal
            show={showModal}
            onHide={() => setShowModal(false)}
            newWatchlistOption={true}
            onSubmit={handleWatchListSubmit}
        />):(<></>)
      }
    </>
  );
}